import React, { useEffect, useRef } from "react";
import { clock, css, flipClock, theme } from "flipclock";

export default function NeonFlipClock({ format = "[hh]:[mm]:[ss][A]", neonColor = "#0f0" }) {
  const clockRef = useRef(null);
  const clockInstance = useRef(null);

  useEffect(() => {
    const container = clockRef.current;

    if (container && !clockInstance.current) {
      clockInstance.current = flipClock({
        parent: container,
        face: clock({ format }),
        theme: theme({
          dividers: ":",
          css: css({
            fontSize: "7rem",
            color: neonColor,
            backgroundColor: "#111",
            borderRadius: "10px",
            textShadow: `
              0 0 8px ${neonColor},
              0 0 16px ${neonColor},
              0 0 24px ${neonColor}
            `
          })
        })
      });

      clockInstance.current.start();
    }

    return () => {
      if (clockInstance.current) {
        clockInstance.current.stop();
        if (container) container.innerHTML = "";
        clockInstance.current = null;
      }
    };
  }, [format, neonColor]);

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <div ref={clockRef}></div>
      <style>{`
        .flip-clock-divider .flip-clock-dot {
          animation: blink 1s infinite;
          background: ${neonColor} !important;
        }
        @keyframes blink {
          0%, 49%, 100% { opacity: 1; }
          50%, 99% { opacity: 0; }
        }
      `}</style>
    </div>
  );
}
